import { ServicesObjectType } from "../../../contexts/ServicesContext";

interface FieldsAndValuesInterface{
  label:string;
  type:string;
  value:keyof ServicesObjectType | any;
}

export const fieldsAndValues:FieldsAndValuesInterface[] = [
  {
    label: 'Quantidade',
    type: 'text',
    value: 'quantity'
  },
  {
    label: 'Etapas',
    type: 'select',
    value: 'stages'
  },
]